import { gql, useQuery } from '@apollo/client';
import { PricesQuery } from './__generated__/PricesQuery';
import { PriceFragment } from './__generated__/PriceFragment';

export const priceFragment = gql`
  fragment PriceFragment on Price {
    id
    name
    amountCents
    interval
  }
`;

export const pricesQuery = gql`
  query PricesQuery {
    prices {
      ...PriceFragment
    }
  }
  ${priceFragment}
`;

export type Plan = 'professional';

export type Interval = 'month' | 'year';

export function useGetPrices() {
  const { data } = useQuery<PricesQuery>(pricesQuery);
  return data?.prices || [];
}

export function useGetPrice<T extends Interval>(interval: T): PriceFragment | undefined;
export function useGetPrice<T extends Interval>(
  interval?: undefined,
): { [key in Interval]?: PriceFragment };
export function useGetPrice<T extends Interval>(interval?: T) {
  const prices = useGetPrices();
  const intervals = prices.reduce<{ [key in T]?: PriceFragment }>(
    (acc, price) => ({
      ...acc,
      [price.interval]: price,
    }),
    {},
  );

  if (interval) {
    return intervals[interval];
  }

  return intervals;
}
